
import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import { FormsModule } from '@angular/forms';
import { RouterModule, ActivatedRoute, Router } from '@angular/router';
import { UserDetailCountComponent } from './user-detail-count/user-detail-count.component';
import { UserDetailInfoComponent } from './user-detail-info/user-detail-info.component';
import { AddService } from 'src/app/shared/services/userservices/add.service';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { Location } from '@angular/common';
import { CommonModule } from '@angular/common';

import Swal from 'sweetalert2';

declare let bootstrap: any;
@Component({
  selector: 'app-user-view',
  templateUrl: './user-view.component.html',
  styleUrl: './user-view.component.css',
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule, UserDetailCountComponent, UserDetailInfoComponent],
})
export class UserViewComponent implements OnInit {
  isLoading = false;

  userUUID = '';
    public showSpinner = false;
  userData: any;
  departments: any;
  organizations: any;
  designations: any;
  employeeType: any;
  statuses: any;
  countryList: any;
  selectedUserUUID: any;
  selectedMode: any;
  uuid: any;
  currentUser: any;
  seleted_user: any;
  actionView = false;


  constructor(private route: ActivatedRoute,
    private addService: AddService,
    public router: Router,
    private sharedmode: SharedModeService,
    private location: Location

  ) {
    this.currentUser = JSON.parse(localStorage.getItem('user') || '');
  }

  ngOnInit() {
  this.route.queryParams.subscribe(params => {
    const fromPage = params['from'];  // "team-management"

    if (fromPage === 'team-management') {
      this.actionView = true;
    } else {
      this.actionView = false;
    }

    console.log("Came from:", fromPage);
  });

    this.getData();
    this.userUUID = this.route.snapshot.paramMap.get('user_uuid')!;
    if (this.userUUID != '' && this.userUUID != null && this.userUUID != undefined) {
      this.getUserDetal(this.userUUID);
    }
  }

  getUserDetal(uuid: any) {
    this.isLoading = true;
    const user_uuid = uuid;
    this.addService.updateUser(uuid).then((value) => {
      debugger
      this.userData = value.data;
      if (this.designations && this.userData.designation_id) {
        this.userData.designation_name = this.getDesignationName(this.userData.designation_id);
      }
      this.isLoading = false;
    
    });
  }

  getDesignationName(designation_id: number): string {
    const designation = this.designations?.find((d: any) => d.id === designation_id);
    return designation ? designation.designation_name : 'N/A';
  }


  getData() {
    this.addService.getStaticData().then((value) => {
      this.departments = value.data.departments;
      this.organizations = value.data.organizationData;
      this.designations = value.data.designationData;
      this.employeeType = value.data.employeeTypes;
      this.statuses = value.data.statuses;
      this.countryList = value.data.country;
    });
  }



  UserUpdate(uuid: string) {
    console.log('Updating user', uuid);

    this.router.navigate(['/employee-add/', uuid]);
    this.addService.updateUser(uuid).then((value) => {
    });
  }

  setUserUUID(uuid: string) {
    this.selectedUserUUID = this.userUUID;
  }
reloadUserData() {
  // Either call the API again to refresh data

  // OR, if you want full page reload (not recommended):
  window.location.reload();
}

  updateSalary(salaryUpdate: NgForm) {
    this.showSpinner = true;

    this.uuid = this.userUUID
    const salary = salaryUpdate.value.newSalary
    const taxSalary = salaryUpdate.value.salaryTax
    this.addService.updateSalary(this.uuid, salary, taxSalary).then((value) => {
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'User Salary Updated Successfully',
          showConfirmButton: false,
          timer: 3000,
        });
        window.location.reload();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    });
  }

  updateAccount(accountUpdate: NgForm) {

     this.showSpinner = true;
    this.uuid = this.userUUID
    const accountNo = accountUpdate.value.ac_number
    this.addService.updateAccountNo(this.uuid, accountNo).then((value) => {
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'User Account No Updated Successfully',
          showConfirmButton: false,
          timer: 3000,
        });
        window.location.reload();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    });
  }

  restrictInputToAccounts(event: Event) {
    const input = event.target as HTMLInputElement;
    let inputValue = input.value;

    const modifiedValue = inputValue.replace(/[^0-9-]/g, '').replace(/-{2,}/g, '-');

    const firstHyphenIndex = modifiedValue.indexOf('-');
    const lastHyphenIndex = modifiedValue.lastIndexOf('-');

    if (firstHyphenIndex !== lastHyphenIndex) {
      const hyphenRemovedValue = modifiedValue.substring(0, lastHyphenIndex) +
        modifiedValue.substring(lastHyphenIndex + 1);
      inputValue = hyphenRemovedValue;
    } else {
      inputValue = modifiedValue;
    }

    if (inputValue !== input.value) {
      input.value = inputValue;
      input.dispatchEvent(new Event('input'));
    }
  }

  updatePassword(passwordUpdate: NgForm) {

     this.showSpinner = true;
    this.uuid = this.userUUID
    const password = passwordUpdate.value.password
    this.addService.updatePassword(this.uuid, password).then((value) => {
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'User Password Updated Successfully',
          showConfirmButton: false,
          timer: 3000,
        });
        window.location.reload();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    });
  }

  updateStatus(statusUpdate: NgForm) {

     this.showSpinner = true;
    this.uuid = this.userData.uuid

    const status = statusUpdate.value.employee_type
    this.addService.updateStatus(this.uuid, status).then((value) => {
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'User Status Updated Successfully',
          showConfirmButton: false,
          timer: 3000,
        });
        window.location.reload();
      } else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 3000,
        });
      }
    });
  }


  isavailablefeature(type: string): boolean {
    if (!this.currentUser?.user_role?.user_roles) {
      return false; // no roles available
    }

    let user_role;
    try {
      // if it's already an object, skip parsing
      user_role = typeof this.currentUser.user_role.user_roles === 'string'
        ? JSON.parse(this.currentUser.user_role.user_roles)
        : this.currentUser.user_role.user_roles;
    } catch (e) {
      console.error("Invalid JSON in user_roles:", e);
      return false;
    }

    const values = user_role?.team_managment?.data?.values ?? {};

    switch (type) {
      case "isView": return values.view ?? false;
      case "isAddUser": return values.add ?? false;
      case "isMothySalary": return values.monthly_salary ?? false;
      case "isDeleteUser": return values.delete ?? false;
      case "isUpdateUser": return values.updateUser ?? false;
      case "isloanReport": return values.loanView ?? false;
      case "isWFH": return values.update ?? false;
      case "isTeamlead": return !(this.userData.department == 'Team Leads');
      default: return false;
    }
  }



   deleteModal(user: any) {
    this.seleted_user = user
    const modalDiv = document.getElementById('deleteModal');
    if (modalDiv != null) {
      modalDiv.style.display = 'block';
    }

  }

  UserDelete() {
    this.seleted_user.uuid
    this.showSpinner = true;
    this.addService.deleteUser(this.seleted_user.uuid).then((value) => {
      this.showSpinner = false;
      
   document.querySelectorAll('.modal.show').forEach(el => el.classList.remove('show'));
  document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
  document.body.classList.remove('modal-open');
  document.body.style.removeProperty('padding-right');
      this.location.back();
    });
  }
 goBack() {
    this.location.back();
  }

  setLoading(loading: boolean) {
    this.isLoading = loading;
  }

}
